import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import TextField from "../inputs/TextField";
import { Link } from "../buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
export interface SSODomainFormInterface {
  handleAction: (type: any, data?: any) => void;
  initialData: { domain: string };
  schema: any;
}
const SSODomainForm = ({
  initialData,
  handleAction,
  schema,
}: SSODomainFormInterface) => {
  const { values, handleChange, handleBlur, handleSubmit, touched, errors } =
    useFormik({
      initialValues: initialData,
      validationSchema: Yup.object(schema),
      onSubmit: (value) => handleAction("submit", value),
    });
  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", height: "100%" }}>
      <Stack
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height="100%"
      >
        <Stack padding={2} textAlign="center">
          <Typography variant="h1" fontWeight={700}>
            Enter your organization’s
            <br />
            SSO domain
          </Typography>
        </Stack>

        <TextField
          name="domain"
          id="domain"
          label="SSO domain"
          placeholder="SSO domain"
          helperText={touched.domain ? errors.domain : ""}
          error={touched.domain && Boolean(errors.domain)}
          value={values.domain}
          onChange={handleChange}
          onBlur={handleBlur}
        />

        <Stack
          spacing={3}
          width="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => handleSubmit()}
          >
            Continue
          </Button>
          <Link
            color="black"
            label="Privacy Policy"
            onClick={() => handleAction("privacyPolicy")}
          />
        </Stack>
      </Stack>
    </form>
  );
};
export default SSODomainForm;
